import { z } from 'zod';
import { StepTemplateSchema } from '../../entities/step-template/step-template.schema';
/** GET /api/v2/step-template — newest first */ export const ListStepTemplatesResponseSchema = z.object({
    data: z.array(StepTemplateSchema)
});

//# sourceMappingURL=list-step-templates.schema.js.map